import React from 'react';
import { IonHeader, IonContent, IonPage } from '@ionic/react';
import Toolbar from '../components/common/Toolbar';
import Typography from '../components/common/Typography';
import TermsAndConditions from '../components/submitCase/components/TermsAndConditions';

interface TermsProps {}

const Terms: React.FC<TermsProps> = (props) => {
  return (
    <IonPage>
      <IonHeader>
        <Toolbar showBackButton showMenu />
      </IonHeader>
      <IonContent>
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '32px 16px' }}>
          <Typography as="h1" fontSize="24px" fontWeight="500">
            Terms &amp; Conditions
          </Typography>
          <TermsAndConditions />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Terms;
